const chartDescriptors = {
  RetirementAssetsAreaChart: {
    chart: {
      type: 'areaspline',
      spacingBottom: 30,
      spacingTop: 60,
      spacingLeft: 0,
      spacingRight: 20,
    },
    title: {
      text: '',
    },
    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
    xAxis: {
      startOnTick: false,
      tickInterval: 10,
      tickWidth: 0,
      categories: [],
      labels: {
        style: {
          fontSize: '12px',
          color: '#6c727f',
          background: '#fff',
          fontFamily: 'Open Sans, helvetica, sans-serif',
        },
      },
      minPadding: 0,
      maxPadding: 0,
    },
    yAxis: {
      title: {
        text: '',
      },
      gridLineColor: '#E5E7EB',
      gridLineDashStyle: 'Dash',
      gridLineWidth: 1,
      labels: {
        formatter() {
          return `$${ADV.util.short_number_format(this.value)}`;
        },
        style: {
          fontFamily: 'Open Sans, helvetica, sans-serif',
          fontSize: '12px',
          color: '#6C727F',
          background: '#fff',
        },
        align: 'right',
        x: 20,
        y: -4,
      },
      maxPadding: 0,
      minPadding: 0,
    },
    plotOptions: {
      areaspline: {
        lineWidth: 0,
        states: {
          hover: {
            enabled: true,
            lineWidth: 0,
            lineWidthPlus: 0,
            halo: {
              opacity: 0.25,
              attributes: {
                fill: '#A7DCF1',
              },
            },
          },
        },
        marker: {
          enabled: false,
          symbol: 'circle',
          radius: 4,
          fillColor: 'white',
          lineColor: '#63b9d4',
          lineWidth: 2,
        },
      },
    },
    series: [
      {
        name: 'v-line-begin',
        lineWidth: 2,
        pointInterval: 0,
        states: {
          hover: {
            enabled: false,
          },
        },
        marker: {
          enabled: false,
        },
        lineColor: '#5abee4',
        enableMouseTracking: false,
        data: [],
      },
      {
        name: 'Proposed Plan Area',
        lineWidth: 2,
        lineColor: '#5abee4',
        fillColor: '#e5f8ff',
        opacity: 0.7,
        states: {
          hover: {
            enabled: false,
          },
        },
        marker: {
          enabled: false,
        },
        data: [],
      },
      {
        name: 'Current Plan Area',
        color: '#5abee4',
        opacity: 0.7,
        states: {
          hover: {
            enabled: false,
          },
        },
        marker: {
          enabled: false,
        },
        data: [],
      },
      {
        name: 'Proposed Plan',
        fillOpacity: 0,
        zIndex: 11,
        data: [],
      },
      {
        name: 'Current Plan',
        fillOpacity: 0,
        zIndex: 10,
        data: [],
      },
    ],
    tooltip: {
      useHTML: true,
      shadow: false,
      borderWidth: 0,
      backgroundColor: 'rgba(255,255,255,0)',
      borderRadius: 0,
      formatter() {
        let planEndedSuffixMessage = '';
        const { isCurrentPlan } = this.point;
        if (this.point.subjectName) {
          if (this.point.y <= 0) {
            planEndedSuffixMessage +=
              `${'<br/><div class="series-hover-state">' +
                `This ${isCurrentPlan ? '' : 'proposed '}plan does not successfully meet `}${
                this.point.subjectName
              }'s life expectancy` + `</div>`;
          } else {
            planEndedSuffixMessage +=
              `${'<br/><div class="series-hover-state">' +
                `This ${isCurrentPlan ? '' : 'proposed '}plan successfully meets `}${
                this.point.subjectName
              }'s life expectancy` + `</div>`;
          }
        }

        let dollarAmount = ADV.util.number_format(this.y, 0);
        if (this.y >= 1e7) {
          dollarAmount = ADV.util.short_number_format(this.y, 2);
        }

        if (this.point.hasSpouse) {
          return (
            `<div class="tooltip"><span class="series-name">${
              this.point.isProposed
                ? `${isCurrentPlan ? 'Current' : 'Proposed'} Plan`
                : this.series.name
            }<div class="year">${this.point.year}</div>` +
            `</span><br><strong>Ages ${this.point.principalAge}/${this.point.spouseAge} <span class="series-value">$${dollarAmount}</span></strong>${planEndedSuffixMessage}</div>`
          );
        }
        return (
          `<div class="tooltip"><span class="series-name">${
            this.point.isProposed
              ? `${isCurrentPlan ? 'Current' : 'Proposed'} Plan`
              : this.series.name
          }<div class="year">${this.point.year}</div>` +
          `</span><br><strong>Age ${this.point.principalAge} <span class="series-value">$${dollarAmount}</span></strong>${planEndedSuffixMessage}</div>`
        );
      },
    },
  },

  MonteCarloSplineChart: {
    chart: {
      type: 'spline',
    },
    credits: {
      enabled: false,
    },
    title: {
      text: '',
    },
    xAxis: {
      labels: {
        step: 5,
        style: {
          fontSize: '14px',
          color: '#6C727F',
          fontFamily: 'Open Sans, helvetica, sans-serif',
        },
        staggerLines: 1,
      },
      tickWidth: 0,
    },
    yAxis: {
      min: 0,
      title: {
        text: '',
      },
      stackLabels: {
        enabled: false,
      },
      labels: {
        formatter() {
          return `$${ADV.util.short_number_format(this.value)}`;
        },
      },
      gridLineColor: '#ddd',
      gridLineDashStyle: 'Dot',
      gridLineWidth: 2,
      style: {
        fontFamily: 'Open Sans, helvetica, sans-serif',
        fontSize: '14px',
        color: '#6C727F',
      },
    },
    legend: {
      enabled: false,
    },
    gridLineWidth: 0,
    plotOptions: {
      spline: {
        marker: {
          enabled: false,
          states: {
            hover: {
              enabled: false,
            },
          },
        },
      },
    },
    tooltip: {
      useHTML: true,
      shadow: false,
      borderWidth: 0,
      backgroundColor: 'rgba(255,255,255,0)',
      borderRadius: 0,
      formatter() {
        return `<div><strong>${this.series.name}</strong><br>Age ${
          this.x
        } / $${ADV.util.number_format(this.y, 0)}</div>`;
      },
    },
  },

  MonteCarloPercentagePieChart: {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      backgroundColor: 'transparent',
      spacing: [0, 0, 0, 0],
      width: 70,
      height: 70,
    },
    title: {
      text: '',
      verticalAlign: 'middle',
    },
    plotOptions: {
      pie: {
        size: 70,
        innerSize: 48,
        dataLabels: {
          enabled: false,
        },
        point: {
          events: {},
        },
      },
      series: {
        states: {
          hover: {
            enabled: false,
          },
        },
      },
    },
    tooltip: {
      formatter() {
        return false;
      },
    },
    series: [
      {
        type: 'pie',
        name: 'Probability of Success',
        data: [],
      },
    ],
    credits: {
      enabled: false,
    },
  },

  RetirementIncomeBreakdownBarChart: {
    chart: {
      type: 'column',
      height: 320,
    },
    title: {
      text: '',
    },
    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
    xAxis: {
      tickInterval: 3,
      tickWidth: 0,
      categories: [],
      labels: {
        style: {
          fontSize: '14px',
          color: '#6c727f',
          fontFamily: 'Open Sans, helvetica, sans-serif',
        },
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: '',
      },
      gridLineColor: '#ddd',
      gridLineDashStyle: 'Dot',
      gridLineWidth: 2,
      labels: {
        formatter() {
          return `$${ADV.util.short_number_format(this.value)}`;
        },
        style: {
          fontFamily: 'Open Sans, helvetica, sans-serif',
          fontSize: '14px',
          color: '#6c727f',
        },
      },
      maxPadding: 0.15,
    },
    plotOptions: {
      column: {
        stacking: 'normal',
        dataLabels: {
          enabled: false,
        },
      },
    },
    series: [
      {
        name: 'Proposed Plan',
        fillColor: '#e5f8ff',
        fillOpacity: 1,
        data: [],
      },
      {
        name: 'Current Plan',
        color: '#5abee4',
        fillOpacity: 1,
        data: [],
      },
    ],
    tooltip: {
      useHTML: true,
      shadow: false,
      borderWidth: 0,
      backgroundColor: 'rgba(255,255,255,0)',
      borderRadius: 0,
      formatter() {
        return `
                    <div class="retirement-income-legend">
                        <span class="retirement-income-legend-icon" style="background-color: ${this.color};"></span>
                        <span class="retirement-income-legend-label">${this.series.name}</span>
                    </div>
                    <div class="click-for-more">Click for more detail</div>
                `;
      },
    },
  },

  LifeInsuranceProgressChartBarChart: {
    chart: {
      type: 'bar',
      spacingBottom: 0,
      spacingLeft: 20,
      spacingRight: 20,
    },
    title: {
      text: '',
    },
    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
    yAxis: {
      title: {
        text: '',
        lineWidth: 0,
        margin: 20,
      },
      gridLineColor: '#ddd',
      gridLineDashStyle: 'Dot',
      gridLineWidth: 2,
      maxPadding: 0,
      tickAmount: 8,
      labels: {
        formatter() {
          return ADV.util.short_number_format(this.value);
        },
        style: {
          fontFamily: 'Open Sans, helvetica, sans-serif',
          fontSize: '13px',
          color: '#888',
        },
      },
    },
    xAxis: {
      title: {
        text: '',
      },
      labels: {
        enabled: false,
      },
      lineWidth: 0,
      maxPadding: 0,
      tickLength: 0,
    },
    series: [
      {
        name: 'Recommended Reserve',
        data: [],
        color: '#e5f8ff',
        fillOpacity: 1,
        borderColor: '#5abee4',
        borderWidth: 2,
      },
      {
        name: 'Current Reserve',
        color: '#5abee4',
        fillOpacity: 1,
        data: [],
        borderColor: '#5abee4',
        borderWidth: 2,
      },
    ],
    tooltip: {
      enabled: false,
    },
    plotOptions: {
      bar: {
        grouping: false,
        shadow: false,
        borderWidth: 0,
        states: {
          hover: {
            enabled: false,
          },
        },
      },
      series: {
        pointWidth: 90,
      },
    },
  },

  DisabilityInsuranceProgressBarChart: {
    chart: {
      type: 'column',
      spacingLeft: 0,
      spacingRight: 0,
    },
    title: {
      text: '',
    },
    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
    xAxis: {
      categories: [],
      labels: {
        enabled: false,
      },
      tickWidth: 0,
      offset: 0,
    },
    yAxis: {
      min: 0,
      title: {
        text: '',
      },
      gridLineColor: '#ddd',
      gridLineDashStyle: 'Dash',
      gridLineWidth: 1,
      lineWidth: 0,
      stackLabels: {
        enabled: false,
      },
      tickWidth: 0,
      labels: {
        formatter() {
          return `$${ADV.util.short_number_format(this.value)}`;
        },
        style: {
          fontFamily: 'Open Sans, helvetica, sans-serif',
          fontSize: '13px',
          color: '#888',
        },
      },
    },
    tooltip: {
      useHTML: true,
      shadow: false,
      borderWidth: 0,
      backgroundColor: 'rgba(255,255,255,0)',
      borderRadius: 0,
      formatter() {
        const y_value =
          this.series.name === 'Current Coverage' ? this.y - this.point.pas_income_value : this.y;
        return (
          `<div><strong>${this.series.name}</strong>` +
          `<div>$${ADV.util.number_format(y_value)}</div></div>`
        );
      },
    },
    plotOptions: {
      column: {
        grouping: false,
        shadow: false,
        borderWidth: 2,
        borderColor: '#5abee4',
        states: {
          hover: {
            enabled: false,
          },
        },
      },
      series: {
        animation: false,
      },
    },
    series: [],
  },

  LongTermCareInsuranceProgressAreaChart: {
    chart: {
      type: 'area',
      spacingBottom: 30,
      spacingTop: 30,
      spacingLeft: 0,
      spacingRight: 0,
      offset: 0,
    },
    title: {
      text: 'Proposed Plan',
      style: {
        fontFamily: "'Open Sans', Helvetica, Arial, sans-serif",
      },
    },
    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
    xAxis: {
      tickInterval: 5,
      tickWidth: 0,
      categories: [],
      labels: {
        style: {
          fontSize: '14px',
          fontWeight: '700',
          color: '#aaa',
          fontFamily: 'Open Sans, helvetica, sans-serif',
        },
      },
    },
    yAxis: {
      title: {
        text: 'Retirement earmarked asset value',
        style: {
          fontFamily: "'Open Sans', Helvetica, Arial, sans-serif",
        },
      },
      gridLineColor: '#ddd',
      gridLineDashStyle: 'Dash',
      gridLineWidth: 1,
      labels: {
        formatter() {
          return `$${ADV.util.short_number_format(this.value)}`;
        },
        style: {
          fontFamily: 'Open Sans, helvetica, sans-serif',
          fontSize: '13px',
          color: '#888',
        },
      },
      maxPadding: 0.15,
    },
    plotOptions: {
      area: {
        animation: false,
        lineWidth: 0,
        marker: {
          enabled: false,
          symbol: 'circle',
          radius: 4,
          fillColor: 'white',
          lineColor: '#63b9d4',
          lineWidth: 2,
          states: {
            hover: {
              enabled: true,
              radius: 6,
            },
          },
        },
      },
    },
    series: [
      {
        name: 'With Additional Coverage',
        fillColor: '#e5f8ff',
        fillOpacity: 1,
        data: [],
      },
      {
        name: 'Current',
        color: '#5abee4',
        fillOpacity: 1,
        data: [],
      },
    ],
    tooltip: {
      useHTML: true,
      shadow: false,
      borderWidth: 0,
      backgroundColor: 'rgba(255,255,255,0)',
      borderRadius: 0,
      formatter() {
        return `<div><strong>${this.series.name}</strong><br>Age ${
          this.x
        } / $${ADV.util.number_format(this.y, 0)}</div>`;
      },
    },
  },
};

export const { RetirementAssetsAreaChart } = chartDescriptors;
export const { MonteCarloSplineChart } = chartDescriptors;
export const { MonteCarloPercentagePieChart } = chartDescriptors;
export const { LifeInsuranceProgressChartBarChart } = chartDescriptors;
export const { DisabilityInsuranceProgressBarChart } = chartDescriptors;
export const { LongTermCareInsuranceProgressAreaChart } = chartDescriptors;
export const { RetirementIncomeBreakdownBarChart } = chartDescriptors;
export default chartDescriptors;
